import { useContext } from 'react';
import Button from '../../../../components/Button';
import themeContext from '../../../../context/theme/themeContext';

const createSpoolSteps = [
    'Choose from an array of supported Asset Types, Yield Generators, and Risk Models. ',
    'Assign the level of your Spool’s Risk Tolerance.',
    'Set your Spool’s Fees, Deploy Spool, and encourage your community to deposit into your Spool’s TVR.',
    'Spool automatically allocates and rebalances funds for the “ideal” outcome.',
    'Earn Fees based on the yield generated from your Spool! The more capital routed through your Spool, the more Fees you earn!',
];

const CreatorFeesFallback = () => {
    const { theme } = useContext(themeContext);

    return (
        <div className='creator-fees-fallback'>
            <span>Not earning any Fees?</span>
            <p>Spools are simple to make!</p>
            <div className={`steps-container ${theme}`}>
                {createSpoolSteps.map((label, index) => (
                    <div className='step-container' key={index}>
                        <div className='circle'>
                            <div className='line' />
                            <div className='inner'>
                                <span>{index + 1}</span>
                            </div>
                        </div>
                        <span>{label}</span>
                    </div>
                ))}
            </div>
            <div className='action-container'>
                <p>Create a Spool to start earning today!</p>
                <Button interalLink='/create-a-spool'>Create a Spool</Button>
            </div>
        </div>
    );
};

export default CreatorFeesFallback;
